<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            :append-to-body="true"
            width="500px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px">
            <el-form-item label="登录名" prop="username">
                <el-input type="text" v-model="dataForm.username" style="width: 80%;"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input :type="pwdFlag ? 'text' : 'password'" v-model="dataForm.password"
                          style="width: 80%;"></el-input>
                <i :class="['el-icon-view',pwdFlag?'pwd-icon':'']" @click="checkPwd" style="margin-left: 10px;"></i>
            </el-form-item>
            <el-form-item label="确认密码" prop="realPwd">
                <el-input :type="pwdFlag ? 'text' : 'password'" v-model="dataForm.realPwd" style="width: 80%;"></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="rid">
                <el-select v-model="dataForm.rid" :disabled="user.rid!==1" style="width: 80%;" filterable
                           placeholder="请选择" clearable>
                    <el-option
                            v-for="item in roleList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <span style="float: left; color: #8492a6; font-size: 12px;">{{ item.labelEn }}</span>
                        <span style="float: right; margin-left: 20px;">
                            {{ item.label }}
                        </span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="enabled">
                <el-switch
                        v-model="disBtn"
                        :disabled="user.rid!==1"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                </el-switch>
                <span v-if="disBtn" class="status-true">正常</span>
                <span v-else class="status-false">禁用</span>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">保存</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {SysUser} from "../../api/sysUser";
    import {SysRole} from "../../api/sysRole";

    export default {
        data() {
            var validateConfirmPassword = (rule, value, callback) => {
                if (this.dataForm.password !== value) {
                    callback(new Error('确认密码与密码不一致'))
                } else {
                    callback()
                }
            };
            return {
                visible: false,
                disBtn: true,
                pwdFlag: false,
                dataForm: {
                    id: 0,
                    username: '',
                    password: '',
                    realPwd: '',
                    rid: 3,
                    urId: 0
                },
                roleList: [],
                dataRule: {
                    username: [
                        {required: true, message: '登录名不能为空', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空', trigger: 'blur'}
                    ],
                    realPwd: [
                        {required: true, message: '确认密码不能为空', trigger: 'blur'},
                        {validator: validateConfirmPassword, trigger: 'blur'}
                    ],
                    rid: [
                        {required: true, message: '请选择角色', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            getRoles() {
                SysRole.getRoles().then(res => {
                    this.roleList = res.roles;
                }).catch(res => {
                    console.log(res)
                })
            },
            //查看密码
            checkPwd() {
                this.pwdFlag = !this.pwdFlag;
            },
            /**
             * 弹窗初始化
             */
            init(id) {
                this.visible = true;
                this.disBtn = true;
                this.pwdFlag = false;
                this.dataForm.id = id;
                this.getRoles();
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                });
                if (this.dataForm.id) { // 查询
                    SysUser.getSysUserInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            this.dataForm.username = res.user.userEntity.username;
                            this.dataForm.password = res.user.userEntity.password;
                            this.dataForm.realPwd = res.user.userEntity.password;
                            this.disBtn = res.user.userEntity.enabled;
                            this.dataForm.rid = res.user.surEntity.rid;
                            this.dataForm.urId = res.user.surEntity.id;
                        }
                    });
                }
            },
            dataFormSubmit() {
                let datas = {
                    'id': this.dataForm.id,
                    'username': this.dataForm.username,
                    'password': this.dataForm.password,
                    'enabled': this.disBtn,
                    'rid': this.dataForm.rid,
                    'urId': this.dataForm.urId
                };
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'add';
                        SysUser.addOrUpdateSysUser(type, datas).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .status-true {
        padding-left: 10px;
        color: #13ce66;
    }

    .status-false {
        padding-left: 10px;
        color: #ff4949;
    }

    .pwd-icon {
        color: #20a0ff;
    }

</style>
